import React, { useEffect, useState } from 'react';
import InvestorInvestmentDetailContentSC, {
  LeftContentWrapSC,
  RightContentWrapSC,
  TopContentWrapSC,
  BottomContentWrapSC,
  MidContentWrapSC,
} from './investor-investment-detail-content.styled';
import LoanInstallmentTable from './loan-installment-table';
import LoanArrears from './loan-arrears';
import LoanDocuments from './loan-documents';
import LoanSummary from './loan-summary';
import LoanTotals from './loan-totals';
import InlineLoading from '../ui/inline-loading/inline-loading';
import BiddingTable from './loan-bidding-table/loan-bidding-table';

const InvestorInvestmentDetailContent = ({ investmentDetail }) => {
  const [falseLoading, setFalseLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setFalseLoading(false);
    }, 300);
  }, []);

  if (Object.keys(investmentDetail).length <= 0 || falseLoading) {
    return (
      <InvestorInvestmentDetailContentSC>
        <div className="loading-wrap">
          <InlineLoading />
        </div>
      </InvestorInvestmentDetailContentSC>
    );
  }

  return (
    <InvestorInvestmentDetailContentSC>
      <TopContentWrapSC>
        <LeftContentWrapSC>
          <LoanSummary investment={investmentDetail} />
        </LeftContentWrapSC>
        <RightContentWrapSC>
          <LoanTotals investment={investmentDetail} />
        </RightContentWrapSC>
      </TopContentWrapSC>

      {!investmentDetail.guestView &&
      investmentDetail.biddings &&
      investmentDetail.biddings.length ? (
        <MidContentWrapSC>
          <BiddingTable biddings={investmentDetail.biddings} hasAdditionalTop />
        </MidContentWrapSC>
      ) : null}

      <BottomContentWrapSC>
        <LeftContentWrapSC>
          <LoanInstallmentTable
            sales={investmentDetail.investor.sales ? investmentDetail.investor.sales : null}
            loans={
              investmentDetail.investor.schedules.length > 0
                ? investmentDetail.investor.schedules
                : null
            }
            dueInstallmentCount={investmentDetail.status.dueInstallmentCount}
          />
        </LeftContentWrapSC>
        <RightContentWrapSC>
          {Number(investmentDetail.investor.totalTillDue[8]) === 0 ? null : (
            <LoanArrears
              schedules={investmentDetail.investor.schedules}
              daysInArrears={investmentDetail.investor.totalTillDue[12]}
              actualUnpaid={investmentDetail.investor.totalTillDue[8]}
            />
          )}
          {investmentDetail?.documents?.length > 0 ? (
            <LoanDocuments documents={investmentDetail.documents} />
          ) : null}
        </RightContentWrapSC>
      </BottomContentWrapSC>
    </InvestorInvestmentDetailContentSC>
  );
};

export default InvestorInvestmentDetailContent;
